RivalIQ.apps.Overview.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const BenchmarkCompaniesChooserModal = RivalIQ.views.ItemView.extend({
        template: '#benchmarkCompaniesChooserModal',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        ui: {
            modal: '.modal',
            saveBtn: '.x-save',
            select: 'select'
        },

        triggers: {
            'click @ui.saveBtn': 'save'
        },

        behaviors: {
            FormValidator: {
                bindModel: false
            },
            AttributeBuilder: {}
        },

        onAttach: function () {
            const me = this;

            const options = _.filter(RivalIQ.enums.benchmarkCompareAgainstOptions, {
                aggregate: 'average'
            });
            me.ui.select.selectize({
                selectOnTab: true,
                labelField: 'name',
                searchField: 'name',
                valueField: 'id',
                noEmptySelection: true,
                options: options,
                items: [me.model.get('selectedBenchmarkCompareAgainst')],
                wrapperClass: 'riq-select',
                inputClass: 'riq-select-input',
                dropdownClass: 'riq-select-dropdown',
                dropdownContentClass: 'riq-select-dropdown-content',
                render: {
                    item: itemRenderer,
                    option: itemRenderer
                },
                onDropdownOpen: function (dropdown) {
                    dropdown.find('[data-toggle="popover"]').popover();
                },
                onChange: function () {
                    me.$('[data-toggle="popover"]').popover();
                }
            });

            me.$('[data-toggle="popover"]').popover();
        },

        onSave: function () {
            const me = this;

            me.ui.saveBtn.button('loading');
            me.triggerMethod('resetValidationErrors');

            const selectedBenchmarkCompareAgainst = me.formAttrs.selectedBenchmarkCompareAgainst;
            if (selectedBenchmarkCompareAgainst) {
                RivalIQ.state.landscape.set({
                    selectedBenchmarkCompareAgainst: selectedBenchmarkCompareAgainst
                });

                const curation = me.options.dashboardModel.getCuration();

                curation.setGlobalProps({
                    selectedBenchmarkCompareAgainst: selectedBenchmarkCompareAgainst
                }, {
                    navigate: false
                });

                const compareAgainst = App.utils.getSelectedBenchmarkCompareAgainst(selectedBenchmarkCompareAgainst);
                RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.SavedCompareModal, {
                    source: curation.id,
                    compareAgainst: _.kebabCase(compareAgainst.name)
                });
            }

            me.ui.modal.modal('hide');
        }
    });

    function itemRenderer(item) {
        return $.tagHtml('div', {
            html: [
                item.name,
                $.tagHtml('i', {
                    class: ['fa', 'fa-fw', 'fa-color', 'fa-info-circle'],
                    'data-toggle': 'popover',
                    'data-trigger': 'hover',
                    'data-container': 'body',
                    'data-content': item.description
                })
            ].join('&nbsp;')
        });
    }

    views.ChangeBenchmarkCompaniesFilterButton = Marionette.ItemView.mixin({
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        dashboardModelEvents: {
            'change:selectedBenchmarkCompareAgainst': 'render'
        },

        events: {
            click: 'onClicked'
        },
        tagName: 'button',
        template: '#changeBenchmarkCompaniesTemplate',
        className: 'btn btn-default choose-time-period-btn',

        serializeData: function () {
            const selectedBenchmarkCompareAgainst = App.utils.getSelectedBenchmarkCompareAgainst();

            return {
                selectedBenchmarkCompareAgainst: selectedBenchmarkCompareAgainst.name
            };
        },

        onClicked: function () {
            const me = this;

            RivalIQ.execute('show:modal', new BenchmarkCompaniesChooserModal({
                dashboardModel: me.dashboardModel,
                model: new Backbone.Model({
                    selectedBenchmarkCompareAgainst: RivalIQ.state.landscape.get('selectedBenchmarkCompareAgainst')
                })
            }));

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.OpenedCompareModal, {
                source: me.dashboardModel.getCuration().id
            });
        }
    });
});
